import React, { ReactNode } from "react";
import { ToggleWrapper } from "./ToggleWrapper";
import { ToggledFeature } from "./featureToggleService";

export function RoadmapVideoUrlToggleWrapper(
  props: {
    children: ReactNode,
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.ROADMAP_VIDEO_URL}>
      {props.children}
    </ToggleWrapper>
  )
}
